export const h ={
    "common": {
        "webSuffix": "- QIDI Tech",
        "email": "brevlåda",
        "password": "lösenord",
        "verificationCode": "Kontrollkod",
        "username": "användarnamn",
        "readAndAgree": "Jag håller med",
        "and": "och",
        "userAgreement": "Användaravtal",
        "privacyPolicy": "Sekretesspolicy",
        "copy": "upphovsrätt ©  Från och med 2025 reserverar Di ägandet",
        "sendVerificationCode": "Skicka verifieringskod",
        "Sending": "Skickar",
        "tryAgainInSeconds": "Försök igen om några sekunder",
        "userNameRequired": "ange ett användarnamn",
        "passwordInputLabel": "Ange ett lösenord",
        "checkPasswordInputLabel": "Ange bekräftelselösenordet",
        "userEmailRequired": "Ange din e-postadress",
        "userEmailInvalid": "Ange rätt e-postadress",
        "emailCodeRequired": "Ange verifieringskoden",
        "newPasswordInputLabel": "Ange ett nytt lösenord",
        "confirmPasswordInputLabel": "Ange ditt lösenord igen",
        "passwordMismatchErrorLabel": "Lösenordet som angetts två gånger är inkonsekvent",
        "agreementRequired": "Vänligen läs och acceptera avtalet",
        "tip": "Tips",
        "tipAlreadyLogin": "Upptäckte att du har loggat in, omdirigerat till användarcentret åt dig",
        "tipWelcomeBack": "Välkommen tillbaka~",
        "tipDeleteAccountFail": "Misslyckades ta bort kontot, gränssnittet för borttagning av kontot stängs tillfälligt",
        "pleaseAgreeFirst": "Kom överens först.",
        "agree": "enas",
        "refuse": "vägra",
        "tipNeedLogin": "Logga in först",
        "tipChangePasswordSuccess": "Lösenordet ändrats framgångsrikt, vi kommer att omdirigera dig till inloggningssidan",
        "tipGetUserInfoSuccess": "Framgångsrikt erhållen information",
        "tipGetUserInfoFail": "Fel med att hämta information",
        "tipLoginOut": "Logga ut och logga in",
        "delete": "ta bort",
        "back": "retur",
        "init": "initiering",

        "passwordInputLengthErrorLabel": "Lösenordslängden bör vara mellan 6 och 20",
        "changePasswordFail": "Ursprungligt lösenord felaktigt",
        "tipDeleteAccountSuccess": "Konto raderat med lyckat resultat",
        "emailCodeSentSuccess": "Kontrollkoden har utfärdats",
        "emailCodeSentFail": "Utfärdande av verifieringskod misslyckades",
        "emailLoginFail": "Verifieringskoden har löpt ut",
        "passwordLoginFail": "Inloggningslösenord felaktigt",
        "editUserInfoSuccess": "Ändrad användarinformation",
        "registerSuccess": "registrerad framgångsrikt",
        "registerFail": "inloggning har misslyckats",
        "registerEmailExistFail": "E-post finns redan",

        "resMessageTip0": "okänd information",
        "resMessageTip1": "Lösenordsfel",
        "resMessageTip2": "Lösenordslängden bör vara mellan 6 och 20",
        "resMessageTip3": "Kontofel",
        "resMessageTip4": "Kontrollkoden har utfärdats",
        "resMessageTip5": "Utfärdande av verifieringskod misslyckades",
        "resMessageTip6": "Verifieringskoden har löpt ut",
        "resMessageTip7": "Lösenordsfel",
        "resMessageTip8": "Lösenordet kan inte vara detsamma som det gamla lösenordet",
        "resMessageTip9": "E-post finns redan",
        "resMessageTip10": "registrerad framgångsrikt",
        "resMessageTip11": "inloggning har misslyckats",
        "resMessageTip12": "Ändrad användarinformation",
        "resMessageTip13": "Misslyckades ändra användarinformation",
        "resMessageTip14": "Framgångsrikt uppnådda",
        "resMessageTip15": "Förvärvet misslyckades",
        "resMessageTip16": "Lösenord ändrat med lyckat resultat",
        "resMessageTip17": "Misslyckades ändra lösenord",
        "resMessageTip18": "Återställning av lösenord lyckades",
        "resMessageTip19": "Återställning av lösenord misslyckades",
        "resMessageTip20": "Inloggning lyckad",
        "resMessageTip21": "Inloggning misslyckades",
        "resMessageTip22": "Konto raderat med lyckat resultat",
        "resMessageTip23": "Misslyckades ta bort konto",
        "resMessageTip24": "Verifieringskoden är felaktig",
        "noUserInfoError": "Nätverksfel, logga in igen"
    },
    "changePassword": {
        "newPassword": "Nytt lösenord"
    },
    "deleteUser": {
        "tipDeleteUser": "Tyvärr måste du gå. När ditt konto har raderats försvinner alla dina personuppgifter permanent och kan inte återställas.",
        "accountDeletionTerms": "Villkor för radering av konto"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Hämta lösenord via e-post",
        "confirmPassword": "Bekräfta lösenord",
        "resettingPassword": "återställ lösenord",
        "resetting": "Återställ"
    },
    "login": {
        "passwordLogin": "Inloggning av lösenord",
        "verifyLogin": "Verifiera inloggning",
        "accountRegistration": "Kontoregistrering",
        "forgotPassword": "Glömt lösenord",
        "login": "Logga in",
        "localLogin": "Lokal inloggning",
        "loginOut": "Logga ut",
        "continueOnYourWay": "Fortsätt på din väg"
    },
    "register": {
        "registerAnAccount": "Registrera ett konto",
        "register": "register"
    },
    "userCenter": {
        "personalInformation": "personuppgifter",
        "modifyInformation": "Ändra information",
        "changePassword": "Ändra lösenord",
        "cancelAccount": "Avbryt konto",
        "exitAccount": "Avsluta konto",
        "change": "ändra",
        "maxCharLimitTip": "Användarnamnet får inte överstiga 10 kinesiska tecken",
    },
    "policies": {
        "deleteAccountPrivacy": "Ta bort kontoavtal",
        "agreement": "Användningsavtal",
        "privacyPolicy": "Sekretesspolicy"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Välj land eller region",
        "recommendedVisits": "Rekommenderat besök",
        "NorthAmerica": "Nordamerika",
        "Europe": "Europa",
        "Asia": "Asien",
        "Other": "Annat",
    }
}

export const aAndL ={
    "ar": {
        "Country": "arabiska",
        "Language": "Arabiska"
    },
    "cs": {
        "Country": "Tjeckien",
        "Language": "Tjeckiska"
    },
    "de": {
        "Country": "Tyskland",
        "Language": "Tyska"
    },
    "en": {
        "Country": "britain",
        "Language": "Engelska"
    },
    "es": {
        "Country": "Spanien",
        "Language": "Spanska"
    },
    "fr": {
        "Country": "Frankrike",
        "Language": "Franska"
    },
    "he": {
        "Country": "Israel",
        "Language": "Hebreiska"
    },
    "hu": {
        "Country": "Ungern",
        "Language": "Ungerska språket"
    },
    "it": {
        "Country": "Italien",
        "Language": "Italienska"
    },
    "ja": {
        "Country": "Japan",
        "Language": "Japanska"
    },
    "ko": {
        "Country": "Republiken Korea",
        "Language": "Koreanska"
    },
    "nl": {
        "Country": "Nederländerna",
        "Language": "Nederländska"
    },
    "pt": {
        "Country": "Portugal",
        "Language": "Portugisiska"
    },
    "pt_BR": {
        "Country": "Portugal (Brasilien)",
        "Language": "Portugisiska (Brasilien)"
    },
    "ru": {
        "Country": "Ryssland",
        "Language": "Ryska"
    },
    "sv": {
        "Country": "Sverige",
        "Language": "Svenska språket"
    },
    "tr": {
        "Country": "Türkiyefrance. kgm",
        "Language": "Turkiska"
    },
    "uk": {
        "Country": "Ukraina",
        "Language": "Ukrainska språket"
    },
    "zh": {
        "Country": "Kinesiska fastlandet",
        "Language": "Förenklad kinesiska"
    },
    "zh_tw": {
        "Country": "Taiwan, Kina",
        "Language": "Traditionell kinesisk"
    },
    "Canada": {
        "Country": "Kanada",
        "Language": "Engelska"
    },
    "United_States": {
        "Country": "USA",
        "Language": "Engelska"
    },
    "United_Kingdom": {
        "Country": "britain",
        "Language": "Engelska"
    },
    "EU_Countries": {
        "Country": "EU-länder",
        "Language": "Engelska"
    },
    "Australia": {
        "Country": "Australien",
        "Language": "Engelska"
    },
    "globalzh": {
        "Country": "Globalt",
        "Language": "Förenklad kinesiska"
    },
    "globalen": {
        "Country": "Global",
        "Language": "Engelska"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/sv.js